import { Injectable } from '@angular/core';

declare var $: any;

@Injectable()
export class DcNestedReport {
  static serialize() {
    let nested = [];
    $('.report-model > .dd-list > .dd3-item').each(function (i, section) {
      let newSection = {
        id: $(section).data('id'),
        children: []
      };
      $(section).find('> .dd-list > .dd3-item').each(function (j, category) {
        let newCategory = {
          id: $(category).data('id'),
          children: []
        };
        $(category).find('> .dd-list > .dd3-item').each(function (k, item) {
          newCategory.children.push({
            id: $(item).data('id')
          });
        });
        newSection.children.push(newCategory);
      });
      nested.push(newSection);
    });

    return nested;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/common/services/nested-report.service.ts